import { Component, inject } from '@angular/core';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFormBuilderComponent,
  formBuilder,
} from '@controladad/ng-base';
import { UserEntity, WalletTransactionCreate } from '@models';
import { WalletTransactionApiService } from '../../../services';
import { formControl, Validators } from '@al00x/forms';

export interface WalletTransactionDialogData {
  customer: UserEntity;
}

export type WalletTransactionDialogResult = boolean;

@Component({
  selector: 'lib-wallet-transaction-dialog',
  standalone: true,
  imports: [CacDialogLayoutComponent, CacFormBuilderComponent],
  templateUrl: './wallet-transaction-dialog.component.html',
  styleUrl: './wallet-transaction-dialog.component.scss',
})
export class WalletTransactionDialogComponent extends CacBaseDialogComponent<
  WalletTransactionDialogData,
  WalletTransactionDialogResult
> {
  private readonly walletTransactionApi = inject(WalletTransactionApiService);

  readonly transactionTypeItems = [
    { value: 0, label: 'Withdraw' },
    { value: 1, label: 'Deposit' },
  ];

  form = formBuilder({
    cols: 1,
    inputs: {
      amount: {
        control: formControl<number>(undefined, [Validators.required, Validators.min(0.01)]),
        label: 'Amount',
        inputType: 'number',
      },
      type: {
        control: formControl<number>(1, Validators.required), // Default to Deposit
        label: 'Transaction Type',
        type: 'select',
        items: this.transactionTypeItems,
        searchable: false,
        clearable: false,
      },
      comment: {
        control: formControl<string>(''),
        label: 'Comment (Optional)',
        type: 'textarea',
      },
    },
  });

  get customerName(): string {
    const customer = this.data.customer;
    return customer.fullName || [customer.firstName, customer.lastName].filter(Boolean).join(' ') || customer.email;
  }

  onSubmit(e: ButtonClickEvent) {
    const values = this.form.getValue();
    if (!values) return;

    const transactionData: WalletTransactionCreate = {
      userId: this.data.customer.id,
      type: values.type,
      amount: values.amount,
      comment: values.comment || null,
    };

    this.walletTransactionApi
      .createAdminTransaction(transactionData)
      .pipe(e.pipe())
      .subscribe(() => {
        this.submit(true);
        snackbar$.show('Wallet transaction created successfully');
      });
  }
}
